import { r as registerInstance, h, H as Host, g as getElement } from './index-5faac9d7.js';
import { R as REVIEW_SECTION_ANCHOR } from './currency-49e0d692.js';

const bazaarVoiceReviewCss = ".bv__review{display:block;box-sizing:border-box;background:#ffffff}.bv__review *,.bv__review *::before,.bv__review *::after{box-sizing:inherit}.bv__header{color:#3dcd58;font-size:1rem;font-weight:bold;line-height:1.5625rem;margin-top:20px;margin-bottom:20px}@media screen and (min-width: 980px){.bv__header{font-size:1.75rem;margin:auto;margin-top:40px;max-width:1200px}}.bv__content{max-width:1200px;margin:0 auto}";

const BazaarVoiceReview = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.host = null;
    this.productId = undefined;
    this.bazaarVoiceEnabled = undefined;
    this.bazaarVoiceHeading = undefined;
  }
  componentDidLoad() {
    if (window.location.hash === REVIEW_SECTION_ANCHOR) {
      this.scrollToSelf();
    }
  }
  scrollToSelf() {
    if (this.host) {
      this.host.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
  }
  render() {
    if (this.bazaarVoiceEnabled) {
      return (h(Host, { class: "bv__review", id: "bv_section" }, h("pes-collapsible-container", null, h("h2", { class: "bv__header", slot: "header" }, this.bazaarVoiceHeading), h("div", { class: "bv__content" }, h("div", { class: "bv_preloader" }, h("div", { "data-bv-show": "reviews", "data-bv-product-id": this.productId, id: "bvReviews" }))))));
    }
  }
  get host() { return getElement(this); }
};
BazaarVoiceReview.style = bazaarVoiceReviewCss;

export { BazaarVoiceReview as pes_bazaar_voice_review };
